import { DateFormats, localFormat } from 'src/helpers/date-helpers';
import { initReactPdf, RPDF } from './react-pdf';
import React from 'react';

export async function createReport(layout: React.ReactElement): Promise<Blob> {
  await initReactPdf();
  const content = RPDF.pdf(layout);
  // Allow React passive effects (useEffect) to fire before reading the tree.
  // @react-pdf/renderer renders synchronously but schedules passive effects
  // via the scheduler — they only flush when the event loop yields.
  // Repeatable sections are populated from useEffect + setTimeout(0),
  // so we need a second tick to let nested timers complete.
  await new Promise((resolve) => setTimeout(resolve, 0));
  await new Promise((resolve) => setTimeout(resolve, 0));
  const blob = await content.toBlob();
  // Unmount the React tree to clean up CraftJS Editor state
  // so the next call starts with a fresh fiber tree.
  content.updateContainer(null as unknown as React.ReactElement);
  return blob;
}

/*
   This functions triggers standard browser 'Download file' dialog.
   In Chrome it just saves the file to Downloads folder and shows the file in bottom toolbar.
 */
export function triggerDownloadFileDialog(blob: Blob, fileName: string) {
  const data = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = data;
  link.download = fileName;
  link.click();
  setTimeout(function () {
    // For Firefox it is necessary to delay revoking the ObjectURL
    window.URL.revokeObjectURL(data);
  }, 100);
}

export const generateReportFileName = (args: { studyNumber: string; uniqueId: string; formTypes: string[] }) =>
  `Study-${args.studyNumber}-Patient-${args.uniqueId}-${
    args.formTypes.length === 1 ? args.formTypes[0].replace(' ', '_') : 'Records'
  }-${localFormat(new Date(), DateFormats.forFiles)}`;
